/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListAppointmentSlotData } from './genericApiResponseListAppointmentSlotData';
import type { GenericApiResponseListAppointmentSlotMessage } from './genericApiResponseListAppointmentSlotMessage';
import type { GenericApiResponseListAppointmentSlotPagination } from './genericApiResponseListAppointmentSlotPagination';
import type { GenericApiResponseListAppointmentSlotError } from './genericApiResponseListAppointmentSlotError';

export interface GenericApiResponseListAppointmentSlot {
  data?: GenericApiResponseListAppointmentSlotData;
  message?: GenericApiResponseListAppointmentSlotMessage;
  pagination?: GenericApiResponseListAppointmentSlotPagination;
  error?: GenericApiResponseListAppointmentSlotError;
  statusCode?: number;
}
